import { render, staticRenderFns } from "./IconsDialog.vue?vue&type=template&id=66956a92&scoped=true&"
import script from "./IconsDialog.vue?vue&type=script&lang=js&"
export * from "./IconsDialog.vue?vue&type=script&lang=js&"
import style0 from "./IconsDialog.vue?vue&type=style&index=0&id=66956a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66956a92",
  null
  
)

export default component.exports